module.exports = __webpack_public_path__ + "img/logo.d1479673.svg";